import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Text = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M4 8V6.129C4 4.946 4.798 4 5.775 4h12.45C19.211 4 20 4.956 20 6.129V8'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12 20V5'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8 20h8'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.775 4.75c-.444 0-1.025.48-1.025 1.379V8a.75.75 0 1 1-1.5 0V6.129c0-1.466 1.014-2.879 2.525-2.879h12.45c1.524 0 2.525 1.428 2.525 2.879V8a.75.75 0 0 1-1.5 0V6.129c0-.894-.577-1.379-1.025-1.379z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 4.25a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0V5a.75.75 0 0 1 .75-.75'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.25 20a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
